import { Box, Chip, Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  FileUploadButton,
  MultiSelectField,
  StandardDialog,
  TextField,
} from '@roc/ui';
import { store } from 'apps/client-portal-public/src/app/stores/store';
import { AppraisalDetailsV2Store } from 'libs/feature-documents/src/documents/stores/documentForms/appraisalDetailsV2/appraisalDetailsV2Store';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import {
  AmountField,
  ReasonField,
  SelectOrdersField,
  SelectPropertiesField,
} from '../appraisalDetailsV2Fields';
import { CloudUpload } from '@material-ui/icons';

export const ValuationTransferDialog = observer(
  ({
    store,
    open,
    onClose,
  }: {
    store: AppraisalDetailsV2Store;
    open: boolean;
    onClose: () => void;
  }) => {
    const formStore = store.appraisalActionsStore.appraisalActionsFormStore;
    const selectedPropertyIds = formStore.form.fields.propertyIds.value;
    const orders = selectedPropertyIds
      .map(id => store.appraisalActionsStore.ordersByProperyId[id] || [])
      .flat();

    useEffect(() => {
      if (open) {
        store.appraisalActionsStore.reset();
        store.appraisalActionsStore.fetchPropertyValuations();
      }
    }, [open]);

    const dialogContent = (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SelectPropertiesField
            properties={store.properties}
            fieldName="propertyIds"
            formStore={formStore}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectOrdersField
            valuations={orders}
            fieldName="clientValuationReferenceIds"
            formStore={formStore}
          />
        </Grid>
        <Grid item xs={12}>
          <FileUploadButton
            formats=".pdf"
            label={
              <Typography>
                Click here to upload the Appraisal PDF document
              </Typography>
            }
            onRemove={() => {
              store.appraisalActionsStore.setUploadedFile(null);
            }}
            onUpload={file => store.appraisalActionsStore.setUploadedFile(file)}
            uploadedFile={store.appraisalActionsStore.uploadedFile}
          />
        </Grid>
        {store.appraisalActionsStore.uploadedFile && (
          <Grid item xs={12}>
            {store.appraisalActionsStore.uploadedFile.name}
          </Grid>
        )}
      </Grid>
    );

    const dialogActions = (
      <>
        <Button
          testId="closeButton"
          variant="outlined"
          color="primary"
          onClick={onClose}
          style={{ marginRight: 8 }}
        >
          CLOSE
        </Button>
        <Button
          testId="submitButton"
          color="primary"
          variant="contained"
          onClick={() => store.appraisalActionsStore.valuationTransfer()}
        >
          SUBMIT
        </Button>
      </>
    );

    return (
      <StandardDialog
        open={open}
        maxWidth="sm"
        title="Valuation Transfer"
        handleClose={onClose}
        dialogContent={dialogContent}
        dialogActions={dialogActions}
      />
    );
  }
);

const useUploadStyles = makeStyles(theme => ({
  uploadButton: {
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: '#FAFAFA',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
  },
  uploadIcon: {
    marginRight: '12px',
    color: '#666',
  },
  uploadText: {
    color: '#1976D2',
    fontSize: '14px',
  },
}));
